import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import {
  TableTr,
  TableWrapper,
  TableHead,
  TableTh,
  TableBody,
} from 'design/table';
import {
  PartnerClientsTableGroup,
  PartnerClientsTableItem,
} from 'types/partnerClientsTable';
import { PartnerPaidClientsTableRow } from 'containers/PartnerClientsTable/PartnerPaidClientsTableRow';
import { HoverableTooltipComponent } from 'design/hoverableTooltip/hoverableTooltipComponents';
import { UnderlinedTextComponent } from 'design/underlinedText/underlinedTextComponents';

type Props = {
  group: PartnerClientsTableGroup;
  activeItemId: null | number;
  onItemClick(item: PartnerClientsTableItem): void;
};

export const PartnerPaidClientsTableGroup = (props: Props) => {
  const {
    group: { items },
    activeItemId,
    onItemClick,
  } = props;

  const {
    partnerClientsTable: ownDictionary,
    shared: sharedDictionary,
  } = useIntlDictionary();

  const monthDateISO = React.useMemo(() => {
    return new Date().toISOString();
  }, []);

  // Мемоизированные строки таблицы клиентов.
  const tableRowsNode = React.useMemo(() => {
    return items.map((item) => (
      <PartnerPaidClientsTableRow
        key={item.id}
        monthDateISO={monthDateISO}
        active={activeItemId === item.id}
        item={item}
        onClick={onItemClick}
      />
    ));
  }, [items, monthDateISO, activeItemId, onItemClick]);

  return (
    <TableWrapper>
      <TableHead>
        <TableTr>
          <TableTh size="m" text={ownDictionary.organizationLabel} />
          <TableTh size="auto" text={ownDictionary.contactFullNameLabel} />
          <TableTh size="m" text={ownDictionary.positionLabel} />
          <TableTh size="l" text={ownDictionary.phoneLabel} />
          <TableTh size="s" text={ownDictionary.orgSizeLabel} />
          <TableTh
            size="m"
            text={
              <HoverableTooltipComponent
                text={sharedDictionary.licensesTooltipText}
              >
                <UnderlinedTextComponent>
                  {ownDictionary.licensesCountLabel}
                </UnderlinedTextComponent>
              </HoverableTooltipComponent>
            }
          />
          <TableTh size="m" text={ownDictionary.incomeLabel} />
          <TableTh size="m" text={ownDictionary.paybackLabel} />
          <TableTh size="l" text={ownDictionary.subscribtionStatusLabel} />
        </TableTr>
      </TableHead>
      <TableBody>{tableRowsNode}</TableBody>
    </TableWrapper>
  );
};
